<template>
  <v-card :class="{ 'free-package': price === 0 }" class="pricing-card transition">
    <div>
      <div class="title-card">
        <h4 class="display-1">
          {{ title }}
        </h4>

        <p class="text-subtitle-2 mb-2" v-if="price > 0">
          <span v-t="'Price per bookable service provider:'" />
        </p>

        <v-chip color="success" class="px-3 mb-1" style="font-size: 1rem">
          <div v-if="price > 0">
            <div>
              <strong v-if="interval === 'year'" class="pr-1">{{ price / 12 / 100 }} €</strong>
              <strong v-else class="pr-1">{{ price / 100 }} €</strong>
              /
              <span v-t="'month'" />
            </div>
          </div>
          <div v-else><span v-t="'Free plan'" /></div>
        </v-chip>
        <div v-if="price > 0" class="text-center">
          <div class="relative text-subtitle-2" v-if="interval === 'year'">
            <small class="text">
              {{ $t("billed annually {0} €", [price / 100]) }}
            </small>
          </div>
          <div class="relative text-subtitle-2">
            <small class="text">{{ $t("VAT excluded") }}</small>
          </div>
        </div>
      </div>
    </div>

    <ul class="mt-5">
      <li v-if="!full && precedingPackageTitle" class="d-flex mr-md-2">
        <v-icon class="mr-2 ml-md-3" color="success">mdi-check</v-icon>
        {{ $t("Everything from {0}", [`"${precedingPackageTitle}"`]) }}
      </li>
      <li v-for="(item, index) in features" :key="index" class="d-flex mr-md-2">
        <v-icon class="mr-2 ml-md-3" color="success">mdi-check</v-icon>
        {{ item }}
      </li>
      <li
        v-for="(item, index) in disabledFeatures"
        :key="index + 'd'"
        class="text--disabled d-flex mr-md-2"
      >
        <v-icon class="mr-2 ml-md-3" disabled>mdi-minus</v-icon>
        {{ item }}
      </li>
    </ul>
    <div class="btn-area pb-7">
      <slot v-bind="{ packageType }" name="alert-area"></slot>
      <slot name="button-area"></slot>
      <!-- <div class="px-3 px-md-5 pt-5 text-left">
        <small>{{ description }}</small>
      </div> -->
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    price: {
      type: Number,
      required: true,
    },
    features: {
      type: Array,
      required: true,
    },
    disabledFeatures: {
      type: Array,
      default: () => [],
    },
    description: {
      type: String,
      required: true,
    },
    packageType: {
      type: String,
      default: "",
    },
    interval: {
      type: String,
      required: true,
    },
    full: {
      type: Boolean,
      default: false,
    },
    precedingPackageTitle: {
      type: String,
      default: null,
    },
  },
  computed: {
    unit() {
      if (this.interval === "year") return "per year";
      if (this.interval === "month") return "per month";
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/_shared/scss/saas/dependencies.scss";

.pricing-card {
  position: relative;
  border-radius: 40px !important;
  overflow: hidden;
  text-align: center;
  border: 1px solid transparent;
  margin-bottom: $spacing3;
  ul {
    padding: spacing(0, 2);
    margin-bottom: $spacing3;
    list-style: none;
    li {
      list-style: none;
      font-size: 16px;
      text-align: left;
      padding: 9px 0;
      margin: 0 !important;
      border-bottom: 1px dashed;
      @include palette-divider;
      &:last-child {
        border-bottom: none;
      }
    }
  }
  &:hover {
    @include use-theme(
      box-shadow,
      0 0 20px 5px $palette-primary-light,
      0 0 20px 5px $dark-background-default
    );
    border: 1px solid $palette-primary-main;
  }
}

.title-card {
  padding: spacing(3, 0, 1);
  font-size: 24px;
  position: relative;
  @include use-theme(color, $palette-primary-dark, $palette-primary-light);
  p {
    font-weight: $font-medium;
    font-size: 16px;
  }
  h4 {
    @include palette-text-secondary;
    font-weight: $font-bold;
    text-transform: none;
    margin-top: $spacing2;
  }
}

.btn-area {
  @include palette-text-secondary;
  position: relative;
  .button {
    margin-top: $spacing2;
  }
}

.free-package {
  .title-card {
    @include use-theme(color, $palette-secondary-dark, $palette-secondary-light);
  }

  &:hover {
    border-color: $palette-secondary-main;
  }
}

.value {
  //   z-index: 40;
  //   border: 1px solid $palette-primary-main;
  .title-card {
    padding-bottom: 0;
    margin-bottom: $spacing5;
    color: $palette-common-white;
    min-height: 60px;
    padding-top: 20px;
    .text {
      position: relative;
      color: $palette-common-white;
    }
    h4 {
      position: relative;
      color: $palette-common-white;
    }
    p {
      position: relative;
    }
    &:before {
      content: "";
      width: 160%;
      position: absolute;
      border-radius: 50%;
      bottom: -20px;
      height: 400px;
      left: -30%;
      background: linear-gradient(-185deg, $palette-primary-main 60%, $palette-primary-dark 100%);
    }
  }
  &:hover {
    @include use-theme(
      box-shadow,
      0 0 20px 5px $palette-primary-light,
      0 0 20px 5px $dark-background-default
    );
  }
}

.news {
  display: flex;
  .v-application--is-rtl & {
    direction: rtl;
  }
  @include breakpoints-down(xs) {
    flex-direction: column;
  }
  p {
    margin-bottom: 0;
  }
  figure {
    overflow: hidden;
    border-radius: $rounded-small;
    margin: 0;
    @include margin-right($spacing2);
    width: 120px;
    height: 140px;
    @include breakpoints-down(xs) {
      width: auto;
      height: auto;
      max-height: 200px;
      margin: spacing(2, 1);
    }
    img {
      max-height: 100%;
      @include margin-left(50%);
      .v-application--is-rtl & {
        transform: translateX(50%);
      }
      .v-application--is-ltr & {
        transform: translateX(-50%);
      }
      @include breakpoints-down(xs) {
        width: 100%;
        height: auto;
      }
    }
  }
}

.text {
  padding: spacing(0, 1.5);
  max-width: 400px;
}

.type {
  font-weight: $font-bold;
  text-transform: uppercase;
  @include palette-text-secondary;
}

.btn {
  margin-top: $spacing2;
  @include margin-left($spacing1);
  @include use-theme(color, $palette-primary-main, $palette-primary-light);
}
</style>
